(() => {
  if (window.__oddOneCartCaptionFixLoaded) return;
  window.__oddOneCartCaptionFixLoaded = true;

  const PREVIEW_PROPERTY = '_odd_one_preview_url';
  const POSTER_CAPTION_Y = 0.87;
  const nativeFetch = window.fetch.bind(window);
  let patchTimer = 0;
  let cartPromise = null;
  let cartPromiseAt = 0;

  function posterCustomizer() {
    return document.querySelector('.odd-one-native[data-profile="poster"]');
  }

  function syncPosterCaptionClass() {
    document.documentElement.classList.toggle('odd-one-poster-caption-fix', Boolean(posterCustomizer()));
  }

  const style = document.createElement('style');
  style.textContent = `
    html.odd-one-poster-caption-fix .odd-one-native-preview__caption {
      top: 87% !important;
    }

    .odd-one-native__choices[data-odd-fonts] .odd-one-native__font[data-font="meddon"] {
      order: -1;
    }

    .odd-one-native__choices[data-odd-fonts] .odd-one-native__font[data-font="rouge-script"] {
      order: 1;
    }
  `;
  document.head.appendChild(style);

  window.fetch = function oddOnePatchedFetch(input, init) {
    try {
      const url = typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : (input && input.url) || '';

      if (
        posterCustomizer()
        && url.includes('/api/shopify/design')
        && init
        && typeof init.body === 'string'
      ) {
        const payload = JSON.parse(init.body);
        if (
          (payload?.action === 'finalize' || payload?.action === 'caption')
          && payload?.caption?.position
        ) {
          payload.caption = {
            ...payload.caption,
            position: {
              ...payload.caption.position,
              y: POSTER_CAPTION_Y,
            },
          };
          init = { ...init, body: JSON.stringify(payload) };
        }
      }
    } catch (_) {
      // Leave unrelated requests untouched.
    }

    return nativeFetch(input, init);
  };

  function cartJsonUrl() {
    const root = window.Shopify?.routes?.root || '/';
    const base = root.endsWith('/') ? root : `${root}/`;
    return `${base}cart.js`;
  }

  async function loadCart(force) {
    const now = Date.now();
    if (!force && cartPromise && now - cartPromiseAt < 150) return cartPromise;

    cartPromiseAt = now;
    cartPromise = nativeFetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => {
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response.json();
    });

    try {
      return await cartPromise;
    } finally {
      window.setTimeout(() => {
        cartPromise = null;
      }, 0);
    }
  }

  async function patchCartPreviewImages(force = false) {
    const rows = Array.from(document.querySelectorAll('.cart-items__table-row[data-key]'));
    if (!rows.length) return;

    try {
      const cart = await loadCart(force);
      const itemsByKey = new Map(
        (cart.items || []).map((item) => [String(item.key), item]),
      );

      rows.forEach((row) => {
        const item = itemsByKey.get(String(row.dataset.key || ''));
        const previewUrl = item?.properties?.[PREVIEW_PROPERTY];
        if (typeof previewUrl !== 'string' || !previewUrl) return;

        const image = row.querySelector('.cart-items__media-image');
        if (!(image instanceof HTMLImageElement)) return;

        if (image.getAttribute('src') !== previewUrl) {
          image.setAttribute('src', previewUrl);
        }
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
        if (image.hasAttribute('sizes')) image.removeAttribute('sizes');
        image.dataset.oddOnePreviewUrl = previewUrl;
      });
    } catch (error) {
      console.warn('[Odd One] Could not stabilize the personalized cart preview.', error);
    }
  }

  function scheduleCartPatch(force = false) {
    window.clearTimeout(patchTimer);
    patchTimer = window.setTimeout(
      () => patchCartPreviewImages(force),
      force ? 20 : 70,
    );
  }

  const observer = new MutationObserver((records) => {
    let cartChanged = false;
    let customizerChanged = false;

    for (const record of records) {
      if (record.type === 'attributes') {
        const target = record.target;
        if (
          target instanceof HTMLImageElement
          && target.matches('.cart-items__media-image')
          && target.closest('.cart-items__table-row[data-key]')
        ) {
          cartChanged = true;
        }
        continue;
      }

      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches('.cart-items__table-row[data-key], cart-items-component')
          || node.querySelector('.cart-items__table-row[data-key]')
        ) {
          cartChanged = true;
        }
        if (
          node.matches('.odd-one-native[data-profile="poster"]')
          || node.querySelector('.odd-one-native[data-profile="poster"]')
        ) {
          customizerChanged = true;
        }
      }
    }

    if (cartChanged) scheduleCartPatch(true);
    if (customizerChanged) syncPosterCaptionClass();
  });

  function init() {
    syncPosterCaptionClass();
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes'],
    });
    scheduleCartPatch(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', () => scheduleCartPatch(true));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleCartPatch(true);
  });
  ['cart:update', 'cart:refresh', 'cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleCartPatch(true), true);
  });
})();
